__turbopack_context__.v({
  "container": "ProductLowInventory-module-scss-module__wc_7Sq__container",
  "icon": "ProductLowInventory-module-scss-module__wc_7Sq__icon",
  "text": "ProductLowInventory-module-scss-module__wc_7Sq__text",
});
